import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    
};

export const metaSlice = createSlice({
    name: 'meta',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            else {
                state = {
                    ...state, 
                    ...payload.payload
                };
            }
            return state;
        }
    },
})

export const { edit } = metaSlice.actions

export default metaSlice.reducer